import React, { ReactElement, useEffect, useState } from 'react';
import { ELoginPartTypes } from 'models/loginScreenSetup';
import { IImageData, useLogoSetup } from 'pages/SystemSettingsPage/LogoSetupPage/hooks';
import { Grid } from '@mui/material';
import { Loader } from 'components/atoms/Loader';
import { StyledImg, StyledImgContainer } from './styles';

export const getBase64Data = (image: IImageData) =>
  image ? `data:image/${image.fileType.toLowerCase()};base64,${image.content}` : '';

export const AuthLogoContainer = (): ReactElement => {
  const { getLoginScreen, loginScreenDataParsed } = useLogoSetup();
  const [isLoadingLoginScreen, setLoadingLoginScreen] = useState<boolean>(true);

  const anyLogoPresent: boolean =
    loginScreenDataParsed !== null &&
    loginScreenDataParsed !== undefined &&
    (loginScreenDataParsed[ELoginPartTypes.LOGO_1] !== undefined ||
      loginScreenDataParsed[ELoginPartTypes.LOGO_2] !== undefined ||
      loginScreenDataParsed[ELoginPartTypes.LOGO_3]) !== undefined;

  useEffect(() => {
    setLoadingLoginScreen(true);
    (async () => {
      await getLoginScreen().then(() => {
        setLoadingLoginScreen(false);
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoadingLoginScreen && (
        <Grid sx={{ justifyContent: "center" }}>
          <Loader isLoading={isLoadingLoginScreen} />
        </Grid>
      )}

      {anyLogoPresent && (
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            width: '100%',
            margin: '32px auto 0 auto',
            gap: '32px',
          }}
          columnSpacing={4}
          size={{ xl: 12 }}
        >
          <StyledImgContainer size={{ xs: 4 }}>
            {loginScreenDataParsed?.[ELoginPartTypes.LOGO_1] && (
              <StyledImg src={loginScreenDataParsed[ELoginPartTypes.LOGO_1]} alt="Logo One" />
            )}
          </StyledImgContainer>
          <StyledImgContainer size={{ xs: 4 }}>
            {loginScreenDataParsed?.[ELoginPartTypes.LOGO_2] && (
              <StyledImg src={loginScreenDataParsed[ELoginPartTypes.LOGO_2]} alt="Logo Two" />
            )}
          </StyledImgContainer>
          <StyledImgContainer size={{ xs: 4 }}>
            {loginScreenDataParsed?.[ELoginPartTypes.LOGO_3] && (
              <StyledImg
                src={loginScreenDataParsed[ELoginPartTypes.LOGO_3]}
                alt="Logo Three"
              />
            )}
          </StyledImgContainer>
        </Grid>
      )}
    </>
  );
};
